import { connect } from "react-redux"

import {
    feedCancelModelUpdate,
    feedApplyModelUpdate,
    feedToggleRejectionReasonModal,
    feedModerate
} from "../../../../actions/feed-actions"

import EditFeedFormActionButtonsWidget from "./EditFeedFormActionButtonsWidget"

const mapStateToProps = ({ presentation: { feed } }, props) => ({
    moderationStatus: feed.workingModel.approved,
    canSave: feed.canSave,
    canEdit: true,
    canCancel: feed.canCancel,
    isCreateMode: false,
    isSaving: feed.isSavingItem,
    isRejectReasonModalOpen: feed.isRejectReasonModalOpen,
    suggestedModerationStatus: feed.workingModel.approval_suggestion,
    ...props
})

const mapDispatchToProps = dispatch => ({
    cancel: () => dispatch(feedCancelModelUpdate()),
    save: () => dispatch(feedApplyModelUpdate()),
    approve: () => dispatch(feedModerate(true)),
    reject: () => dispatch(feedToggleRejectionReasonModal()),
    unmoderate: () => dispatch(feedModerate(null))
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(EditFeedFormActionButtonsWidget)
